// src/pages/Home/components/Navbar3/components/NavbarAccountActions.jsx

import React from "react";

import { FaSignOutAlt } from "react-icons/fa";

import HeaderIconButton from "../ui/HeaderIconButton";

import { cx } from "../utils/navbar3.utils";

export default function NavbarAccountActions({
  user,
  avatarUrl,
  variant = "desktop",
  onProfile,
  onLogout,
}) {
  if (!user) {
    return null;
  }

  const isMobile = variant === "mobile";

  const hasUserIdentity =
    Number(user?.userId || user?.id) > 0;

  return (
    <div
      className={cx(
        "flex shrink-0 items-center",
        isMobile
          ? "gap-1 pr-2"
          : "gap-2 pr-4",
      )}
    >
      {hasUserIdentity ? (
        <button
          type="button"
          onClick={onProfile}
          title="Profil & Badges"
          aria-label="Profil & Badges"
          className={cx(
            [
              "flex shrink-0",
              "items-center justify-center",
              "rounded-full",
              "ring-2 ring-white/20",
              "transition duration-200",
              "hover:ring-white/60",
              "active:scale-90",
              "focus-visible:outline-none",
              "focus-visible:ring-4",
              "focus-visible:ring-white/60",
            ].join(" "),
            isMobile
              ? "h-8 w-8"
              : "h-10 w-10",
          )}
        >
          <img
            src={avatarUrl}
            alt="Avatar utilisateur"
            className="
              h-full w-full
              rounded-full
              object-cover
            "
            onError={(event) => {
              event.currentTarget.src =
                "/img/user_avatar.jpg";
            }}
          />
        </button>
      ) : null}

      <HeaderIconButton
        variant={variant}
        label="Déconnexion"
        onClick={onLogout}
        className="
          bg-white/5
          hover:bg-rose-600/80
        "
      >
        <FaSignOutAlt
          className={
            isMobile
              ? "text-sm"
              : "text-base md:text-lg"
          }
        />
      </HeaderIconButton>
    </div>
  );
}